import type { ExtraProfileField } from "@jti/fe-common";

/**
 * Filters profile extra attributes keeping only keys whose values are non-empty strings.
 * Checks values and excludes: non-string, empty after trimming / purely whitespace.
 * Returns a new plain object (shallow) without mutating the input.
 *
 * @example
 *   Input: {
 *      validString: "ok"
 *      validPaddedString: "  fishing  ",
 *      emptyString: "   ",
 *      numberValue: 42,
 *    }
 *   Output: {
 *      validString: "ok"
 *      validPaddedString: "  fishing  ",
 *    }
 */
export const normalizeProfileExtraAttributes = (extraAttributes: ExtraProfileField): ExtraProfileField => {
  const normalizedExtraAttributes: ExtraProfileField = {};

  for (const [key, value] of Object.entries(extraAttributes)) {
    if (typeof value !== "string") continue;
    if (value.trim().length === 0) continue;

    normalizedExtraAttributes[key] = value;
  }

  return normalizedExtraAttributes;
};
